import { render } from "./TheSplashPage.vue?vue&type=template&id=4dd93145&scoped=true"
import script from "./TheSplashPage.vue?vue&type=script&lang=js"
export * from "./TheSplashPage.vue?vue&type=script&lang=js"

import "./TheSplashPage.vue?vue&type=style&index=0&id=4dd93145&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd93145"]])

export default __exports__